export default function TeleAccountSettings() {
    return (
        <div className="p-3">
            <div className="font-medium text-[17px]">Account Settings</div>
        </div>
    )
}